import {
  Card,
  CardBody,
  Col,
  FormGroup,
  FormText,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import LazyImage from "../../web/components/common/LazyImage";
import BoxDynamicAd from "../../ads/BoxDynamicAd";
import { useParams } from "react-router";
import EnterpriseService from "../../common/services/enterprise-service";
import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import LoadingButton from "../ui/LoadingButton";
import { toast, ToastContainer } from "react-toastify";
import remarkGfm from "remark-gfm";
import Separator from "../ui/Separator";
import LoadingOverlay from "react-loading-overlay";
import ErrorBox from "../ui/ErrorBox";
import CompanyHero from "./CompanyHero";

export default function Apply({ container }) {
  let { id, name } = useParams();
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [application, setApplication] = useState({
    discord: "",
    email: "",
    message: "",
    questionnaire: {},
  });
  const [applicationSubmitted, setApplicationSubmitted] = useState(false);

  const [questionnaire, setQuestionnaire] = useState(null);

  const es = new EnterpriseService();
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    getCompany();
  }, []);

  const getCompany = async () => {
    setLoading(true);
    let company = null;

    if (id) company = await es.getCompany(id);
    else company = await es.getCompanyBySlug(name);

    if (company && company.id) {
      setCompany(company);
      getQuestionnaire(company.id);
    } else {
      setNotFound(true);
    }
    setLoading(false);
  };

  const checkRequiredQuestions = () => {
    let _errors = [];

    if (application.message == "") {
      _errors.push(
        container.localeManager.strings.pleaseInsertApplicationMessage
      );
    }
    if (questionnaire && questionnaire.length > 0) {
      for (const q of questionnaire) {
        if (q.is_required && !application.questionnaire[`question_${q.id}`]) {
          _errors.push(
            container.localeManager.formatString(
              container.localeManager.strings.fillQuestionNumber,
              q.question
            )
          );
        }
      }
    }

    if (_errors.length > 0) {
      setErrors(_errors);
      return false;
    } else {
      setErrors([]);
    }
    return true;
  };

  const apply = async () => {
    if (!checkRequiredQuestions()) return;
    setLoading(true);
    const result = await es.applyToCompany(company, application);
    if (result.success) {
      toast.success(container.localeManager.strings.applicationSent);
      setLoading(false);
      setApplicationSubmitted(true);
    } else {
      setErrors([result.message]);
      setLoading(false);
    }
  };

  const getQuestionnaire = async (company_id) => {
    const result = await es.getCompanyQuestionnaire(company_id);
    if (result.error) {
      toast.error(result.message);
    } else {
      setQuestionnaire(result);
    }
  };

  const updateQuestionnaire = (index, question, answer) => {
    setApplication({
      ...application,
      questionnaire: {
        ...application.questionnaire,
        [`question_${question.id}`]: {
          question: question.question,
          answer: answer,
        },
      },
    });
  };

  return (
    <LoadingOverlay
      active={loading}
      spinner={
        <Spinner
          color="primary"
          style={{ width: "4rem", height: "4rem" }}
        ></Spinner>
      }
    >
      <Row noGutters className="d-flex flex-nowrap">
        <Col>
          <Card className="h-100">
            <CardBody>
              {company != null && (
                <>
                  <Row noGutters>
                    <Col>
                      <CompanyHero company={company} />

                      {!applicationSubmitted && (
                        <>
                          <div className="my-3 text-center">
                            <h1>
                              {container.localeManager.formatString(
                                container.localeManager.strings.applyTo,
                                company.name
                              )}
                            </h1>
                          </div>
                          <Separator className="my-3" />
                          {(company.requirements ||
                            company.application_requirements) && (
                            <>
                              <div className="my-3 text-center">
                                <h2>
                                  {container.localeManager.strings.requirements}
                                </h2>
                              </div>
                              <div className="mt-3">
                                <ReactMarkdown
                                  children={
                                    company.application_requirements ||
                                    company.requirements
                                  }
                                  remarkPlugins={[remarkGfm]}
                                />
                              </div>
                              <Separator className="my-3" />
                            </>
                          )}
                          <div className="mt-3">
                            <FormGroup row>
                              <Col md={6}>
                                <Label>
                                  {container.localeManager.strings.discord}{" "}
                                  {
                                    container.localeManager.strings
                                      .discordExample
                                  }
                                </Label>
                                <Input
                                  type="text"
                                  onChange={(e) =>
                                    setApplication({
                                      ...application,
                                      discord: e.target.value,
                                    })
                                  }
                                ></Input>
                              </Col>
                            </FormGroup>
                            {questionnaire &&
                              Array.isArray(questionnaire) &&
                              questionnaire.length > 0 &&
                              questionnaire.map((q, index) => (
                                <FormGroup row key={index}>
                                  <Col md={6}>
                                    {q.type !== "checkbox" && (
                                      <Label>
                                        {q.question} {q.is_required ? "*" : ""}
                                      </Label>
                                    )}
                                    {q.type === "text" && (
                                      <Input
                                        type="text"
                                        onChange={(e) =>
                                          updateQuestionnaire(
                                            index,
                                            q,
                                            e.target.value
                                          )
                                        }
                                      ></Input>
                                    )}
                                    {q.type === "textarea" && (
                                      <Input
                                        type="textarea"
                                        onChange={(e) =>
                                          updateQuestionnaire(
                                            index,
                                            q,
                                            e.target.value
                                          )
                                        }
                                        rows="5"
                                      ></Input>
                                    )}
                                    {q.type === "select" && (
                                      <Input
                                        type="select"
                                        onChange={(e) =>
                                          updateQuestionnaire(
                                            index,
                                            q,
                                            e.target.value
                                          )
                                        }
                                      >
                                        {q.options
                                          .split(",")
                                          .map((option, i) => (
                                            <option
                                              key={i}
                                              value={option.trim()}
                                            >
                                              {option.trim()}
                                            </option>
                                          ))}
                                      </Input>
                                    )}
                                    {q.type === "checkbox" && (
                                      <label class="form-check form-switch form-check-custom form-check-solid">
                                        <input
                                          onChange={(e) =>
                                            updateQuestionnaire(
                                              index,
                                              q,
                                              e.target.checked ? "yes" : "no"
                                            )
                                          }
                                          class="form-check-input"
                                          type="checkbox"
                                        />
                                        <span class="form-check-label">
                                          {q.question}{" "}
                                          {q.is_required ? "*" : ""}
                                        </span>
                                      </label>
                                    )}
                                    {q.type === "radio" &&
                                      q.options.split(",").map((option, i) => (
                                        <>
                                          <Input
                                            type="radio"
                                            className="ms-3"
                                            name={`question_${index}`}
                                            value={option.trim()}
                                            onChange={(e) =>
                                              updateQuestionnaire(
                                                index,
                                                q,
                                                e.target.value
                                              )
                                            }
                                          />
                                          <span className="ms-2">
                                            {option.trim()}
                                          </span>
                                        </>
                                      ))}
                                  </Col>
                                </FormGroup>
                              ))}
                            <FormGroup>
                              <Label>
                                {container.localeManager.strings.message} *
                              </Label>
                              <Input
                                rows="10"
                                cols="10"
                                type="textarea"
                                onChange={(e) =>
                                  setApplication({
                                    ...application,
                                    message: e.target.value,
                                  })
                                }
                              ></Input>
                              {company.application_requirements == null && (
                                <FormText className="muted">
                                  {
                                    container.localeManager.strings
                                      .applicationMessage
                                  }
                                </FormText>
                              )}
                            </FormGroup>
                            <FormGroup className="mt-3">
                              <LoadingButton
                                size="sm"
                                loading={loading}
                                onClick={apply}
                                color="primary"
                              >
                                {
                                  container.localeManager.strings
                                    .sendApplication
                                }
                              </LoadingButton>
                            </FormGroup>
                            {errors.length > 0 && <ErrorBox errors={errors} />}
                            <ToastContainer
                              position="top-right"
                              autoClose={5000}
                              hideProgressBar={false}
                              newestOnTop
                              closeOnClick
                              rtl={false}
                              pauseOnFocusLoss
                              draggable
                              pauseOnHover
                            />
                          </div>
                        </>
                      )}
                      {applicationSubmitted && !loading && (
                        <div className="my-3 text-center">
                          <h2 className="my-10 text-success">
                            {container.localeManager.strings.applicationSent}
                          </h2>
                          <Card className="bg-light">
                            <CardBody>
                              <p className="mt-3 fs-3">
                                {
                                  container.localeManager.strings
                                    .applicationSentMessage1
                                }
                              </p>
                              <p className="mt-3 fs-3">
                                {
                                  container.localeManager.strings
                                    .applicationSentMessage2
                                }
                              </p>
                              <p className="mt-3 fs-3">
                                {
                                  container.localeManager.strings
                                    .applicationSentMessage3
                                }
                              </p>
                              <p className="mt-3 fs-3">
                                {container.localeManager.formatString(
                                  container.localeManager.strings
                                    .applicationSentMessage4,
                                  company.name
                                )}
                              </p>
                            </CardBody>
                          </Card>
                        </div>
                      )}
                    </Col>
                  </Row>
                </>
              )}
            </CardBody>
          </Card>
        </Col>
        <aside className="ad-column-placeholder d-none d-md-block">
          <BoxDynamicAd container={container} className="my-3" />
        </aside>
      </Row>
    </LoadingOverlay>
  );
}
